import { Component, OnInit } from '@angular/core';
import {Router} from "@angular/router";

@Component({
  selector: 'app-doc-vente',
  templateUrl: './doc-vente.component.html',
  styleUrls: ['./doc-vente.component.scss']
})
export class DocVenteComponent implements OnInit {

  constructor(private router : Router) { }

  ngOnInit(): void {
  }
  retour() {
    this.router.navigate(['/main/parametre/document']);
  }
}
